import { IDB_cameraBrowserApi } from '../IDB/IDB.deviceDB'

export interface Devi_CameraSettings {
    forceUseBrowser: boolean
}

export async function Devi_readCameraBrowserApi(): Promise<Devi_CameraSettings> {
    const settings = await IDB_cameraBrowserApi().get()
    /* eslint-disable-next-line no-console */
    console.log({ settings })
    return settings ?? { forceUseBrowser: false }
}
